export class AnalyzeFilterConfig {
  supplyTemp: boolean;
  returnTemp: boolean;
  outdoorTemp: boolean;
  tempBonus: boolean;
  humidity: boolean;
  deltaT: boolean;
  allTemps: boolean;
  compareYear: boolean;
  normalAdjusted: boolean; // Radiobutton
  normalYearAdjustment: boolean; // Checkbox
  displayPerMeteringPoints: boolean;
  displayPerStatus: boolean;
  explicitMeteringPointSelect: boolean;
  displayCategoryEnergy: boolean;
  displayCategoryEffect: boolean;
  displayCategoryBonus: boolean;
  displayCategoryServices: boolean;
  displayCategoryOther: boolean;
  displayCategorySpike: boolean;

  public static initAsTrue = (): AnalyzeFilterConfig => {
    return <AnalyzeFilterConfig>{
      supplyTemp: true,
      returnTemp: true,
      outdoorTemp: true,
      tempBonus: false,
      humidity: true,
      deltaT: true,
      allTemps: true,
      compareYear: true,
      normalAdjusted: true,
      normalYearAdjustment: true,
      displayPerMeteringPoints: true,
      displayPerStatus: true,
      explicitMeteringPointSelect: true,
      displayCategoryEnergy: true,
      displayCategoryEffect: true,
      displayCategoryBonus: true,
      displayCategoryServices: true,
      displayCategoryOther: true,
      displayCategorySpike: true
    };
  };
}
